<script>
export default {
  methods: {
    saveComponentData(componentKey, dataObj) {
      if (dataObj === null) return;
      // Check whether is Object and convert to JSON (since this can only contain strings)
      dataObj instanceof Object
        ? localStorage.setItem(componentKey, JSON.stringify(dataObj))
        : localStorage.setItem(componentKey, dataObj);
    },
    loadComponentData(componentKey) {
      let dataObj = localStorage.getItem(componentKey);
      if (dataObj === null) return false;
      // Check if JSON or not
      try {
        dataObj = JSON.parse(dataObj);
      } catch (e) {
        // Do nothing
      }
      let loaded = false;
      // Assume that keys are in data for this to work
      for (let [k, v] of Object.entries(dataObj)) {
        this[k] = v;
        loaded = true;
      }
      return loaded;
    },
    clearComponentData(componentKey) {
      let dataObj = localStorage.getItem(componentKey);
      if (dataObj === null) return false;
      // Check if JSON or not
      try {
        dataObj = JSON.parse(dataObj);
      } catch (e) {
        // Do nothing
      }
      for (let k of Object.keys(dataObj)) {
        if (Array.isArray(dataObj[k])) {
          this[k] = [];
        } else if (typeof dataObj[k] === "string") {
          this[k] = "";
        } else {
          this[k] = null;
        }
      }
      localStorage.removeItem(componentKey);
    },
  },
  data() {
    return {
      loadedFromStorage: false,
    };
  },
};
</script>
